import {createRef} from 'react';
import Message from '../Message.jsx';

/**
 * Class to define interactive message. These are messages that once a user
 * uses the presented function, the interactive part of the message should
 * be hidden in the chat context.
 */
export default class InteractiveMessage extends Message {
    constructor(props) {
        super(props);

        this.state = {
            userInteracted: false
        };

        this.interactionRef = createRef();
    }

    /**
     * Call the Message.componentDidMount and then set the listeners
     * for the interactive message portion of the template.
     */
    componentDidMount() {
        super.componentDidMount();
        this.setEventListeners();
    }

    /**
     * Set a click listner against the interaction point's parent element.
     * This should target specific buttons/interactive elements and not
     * the white space of the parent element.
     */
    setEventListeners() {
        this.interactionRef.current.addEventListener('click', (/** @type {MouseEvent} */ e) => {
            if (!e.target.classList.contains('button') && !e.target.classList.contains('btn') && !e.target.classList.contains('interaction-button')) {
                return;
            }
            this.setState({userInteracted: true});
        });
    }
}